















































import { State, Action, Getter, Mutation } from "vuex-class";
import { Component, Prop, Vue } from "vue-property-decorator";
import { pageDataType } from "../types";

@Component({
  name: "Accordion",
})
export default class Accordion extends Vue {
  @Prop() readonly compData!: any;
  accordionIndex = 0;
  isActive: boolean = false;
  isAccordion: boolean = true;

  
}
